import React, { useRef, useState, useContext } from "react";
import { BsPinMapFill, BsPhone, BsEnvelope } from "react-icons/bs";
import { FaBed, FaTree, FaPeopleCarry } from "react-icons/fa";
import DonateButton from "../components/Donate";
import Hospital1 from "../assets/Sadaguru Moredada Charitable Hospital 3D2.jpg";
import Hospital2 from "../assets/moredada_hospital.jpg";
import Hospital3 from "../assets/moredada_hospital01.jpg";
import Hospital4 from "../assets/Sadaguru Moredada Charitable Hospital 3D1.jpg";
import VideoThumbnail from "../assets/Akhil Bhartiya Shree Swami Samarth Gurupeeth, Trimbakeshwar.mp4";
import "./SadguruMoredadaHospital.css";
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import Header from "../components/Layout/Header";
import ScrollAnimation from "../components/ScrollAnimations";
import Slider from "react-slick";
import { FiDownload } from "react-icons/fi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { AiOutlineClose } from "react-icons/ai";

const translations = {
  en: {
    header: "Sadguru PP Moredada Hospital",
    aboutTitle: "About Sadguru Moredada Hospital",
    aboutDesc:
      "Sadguru PP Moredada Charitable Hospital is a multi-specialty hospital offering compassionate care to the community. It blends advanced medical treatments with spiritual wellness for holistic health.",
    stats: [
      "Spread across a sprawling 21 acres in picturesque greens",
      "A 1000-bed state-of-the-art multi-specialty hospital",
      "Shri Jan Kalyan Yojna: a unique scheme for ordinary people to contribute in construction of modern hospital to bring health & happiness to millions.",
    ],
    contactTitle: "Contact Info",
    address:
      "Gat No.304/3 Behind Govt Rest House, Ring Road, Survey No 315, Tal. Trimbakeshwar, Dist. Nashik, Maharashtra, India – 422212",
    phone: "+91 2594 234253 / 54",
    email: "moredadahospital@gurupeeth.in",
    gallery: "Gallery",
    view: "View",
    home: "Home",
  },
  mr: {
    header: "सद्गुरु प.पू. मोरेदादा हॉस्पिटल",
    aboutTitle: "सद्गुरु मोरेदादा हॉस्पिटल बद्दल",
    aboutDesc:
      "सद्गुरु प.पू. मोरेदादा चॅरिटेबल हॉस्पिटल ही एक मल्टी-स्पेशालिटी हॉस्पिटल आहे जी समुदायाला सहानुभूतिपूर्ण सेवा प्रदान करते. हे प्रगत वैद्यकीय उपचारांना आध्यात्मिक कल्याणासह एकत्र करते जे संपूर्ण आरोग्यासाठी उपयुक्त आहे.",
    stats: [
      "सौंदर्यपूर्ण हिरव्यागारात विस्तृत २१ एकर क्षेत्र",
      "१०००-आसनांच्या आधुनिक मल्टी-स्पेशालिटी हॉस्पिटल",
      "श्री जन कल्याण योजना: सामान्य लोकांना आधुनिक रुग्णालयाच्या बांधकामात योगदान देण्यासाठी अनोखी योजना, जे लाखो लोकांना आरोग्य आणि आनंद देते.",
    ],
    contactTitle: "संपर्क माहिती",
    address:
      "गट क्र. ३०४/३, गव्हर्नमेंट रेस्ट हाऊस मागे, रिंग रोड, सर्व्हे क्र. ३१५, ता. त्रिंबकेश्वर, जि. नाशिक, महाराष्ट्र, भारत – ४२२२१२",
    phone: "+९१ २५९४ २३४२५३ / ५४",
    email: "moredadahospital@gurupeeth.in",
    gallery: "गॅलरी",
    view: "पहा",
    home: "मुख्यपृष्ठ",
  },
};

export default function SadguruMoredadaHospital() {
  const { lang } = useContext(LanguageContext);
  const [zoomImg, setZoomImg] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const t = translations[lang];

  const images = [Hospital1, Hospital2, Hospital3, Hospital4];
  const videoRef = useRef(null);

  // Handle video play/pause
  const handleVideoClick = () => {
    if (!videoRef.current) return;
    
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };

  // Listen to video play/pause events
  const handlePlay = () => setIsPlaying(true);
  const handlePause = () => setIsPlaying(false);

  // Slider settings
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(3, images.length),
    slidesToScroll: 1,
    arrows: images.length > 3,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 900,
        settings: { slidesToShow: 2, arrows: false },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1, arrows: false, dots: true },
      },
    ],
  };

  return (
    <div className="hospital-page">
      {/* Header */}
      <Header />

      {/* Page Header with Breadcrumb */}
      <ScrollAnimation animation="fade-down">
        <div className="hospital-header">
          <div className="header-center">
            <div className="breadcrumb">
              <Link to="/">{t.home}</Link> &gt; <span>{t.header}</span>
            </div>
            <h1>{t.header}</h1>
          </div>
        </div>
      </ScrollAnimation>

      {/* Main Content */}
      <main className="hospital-main">
        <div className="info-video-container">
          {/* Left Side: Info */}
          <div className="hospital-info-left">
            <ScrollAnimation animation="fade-up" delay={100}>
              <h2>{t.aboutTitle}</h2>
              <p>{t.aboutDesc}</p>
            </ScrollAnimation>

            {/* Highlight Info */}
            <ScrollAnimation animation="fade-up" delay={200}>
              <div className="hospital-stats">
                <ScrollAnimation animation="slide-left" delay={100}>
                  <div className="stat-card">
                    <FaTree className="stat-icon" />
                    <p>{t.stats[0]}</p>
                  </div>
                </ScrollAnimation>

                <ScrollAnimation animation="slide-left" delay={200}>
                  <div className="stat-card">
                    <FaBed className="stat-icon" />
                    <p>{t.stats[1]}</p>
                  </div>
                </ScrollAnimation>

                <ScrollAnimation animation="slide-left" delay={300}>
                  <div className="stat-card">
                    <FaPeopleCarry className="stat-icon" />
                    <p>{t.stats[2]}</p>
                  </div>
                </ScrollAnimation>
              </div>
            </ScrollAnimation>

            {/* Contact Info */}
            <ScrollAnimation animation="fade-up" delay={300}>
              <h3>{t.contactTitle}</h3>
              <div className="contact-info-cards">
                <ScrollAnimation animation="slide-right" delay={100}>
                  <div className="contact-card">
                    <BsPinMapFill className="icon icon-address" />
                    <div>
                      <p>{t.address}</p>
                    </div>
                  </div>
                </ScrollAnimation>

                <ScrollAnimation animation="slide-right" delay={200}>
                  <div className="contact-card">
                    <BsPhone className="icon icon-phone" />
                    <div>
                      <p>{t.phone}</p>
                    </div>
                  </div>
                </ScrollAnimation>

                <ScrollAnimation animation="slide-right" delay={300}>
                  <div className="contact-card">
                    <BsEnvelope className="icon icon-email" />
                    <div>
                      <p>{t.email}</p>
                    </div>
                  </div>
                </ScrollAnimation>
              </div>
            </ScrollAnimation>

            <ScrollAnimation animation="fade-up" delay={400}>
              <div className="hospital-buttons">
                <Link to="/donation">
                  <DonateButton />
                </Link>
              </div>
            </ScrollAnimation>
          </div>

          {/* Right Side: Video */}
          <ScrollAnimation animation="fade-left" delay={200}>
            <div className="hospital-video-card">
              <video
                ref={videoRef}
                src={VideoThumbnail}
                poster={Hospital1}
                className="hospital-video"
                playsInline
                controls
                onPlay={handlePlay}
                onPause={handlePause}
                onEnded={handlePause}
              />
              {!isPlaying && (
                <div className="video-overlay" onClick={handleVideoClick}>
                  <span>▶ Watch Video</span>
                </div>
              )}
            </div>
          </ScrollAnimation>
        </div>

        {/* Gallery Section */}
        <ScrollAnimation animation="fade-up" delay={500}>
          <section className="hospital-gallery">
            <h2>{t.gallery}</h2>
            <Slider {...sliderSettings} className="gallery-slider">
              {images.map((img, i) => (
                <div key={i} className="gallery-slide-wrapper">
                  <div
                    className="gallery-item"
                    onClick={() => setZoomImg(img)}
                  >
                    <img src={img} alt={`Hospital ${i + 1}`} />
                    <div className="gallery-overlay">{t.view}</div>
                  </div>
                </div>
              ))}
            </Slider>

            {/* Zoom Modal */}
            {zoomImg && (
              <div className="zoom-modal" onClick={() => setZoomImg(null)}>
                <AiOutlineClose
                  className="zoom-close-icon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setZoomImg(null);
                  }}
                  size={28}
                />

                <img src={zoomImg} alt="Zoomed" />
                <a
                  href={zoomImg}
                  download
                  className="download-icon"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FiDownload size={24} />
                </a>
              </div>
            )}
          </section>
        </ScrollAnimation>
      </main>
    </div>
  );
}